module.exports = __webpack_public_path__ + "02_glasses_black.bb3666ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/female/layer4/02_glasses_black.png
// module id = Xd9e
// module chunks = 0